export enum QuizEvaluationType {
	Correct = 'correct',
	InCorrect = 'incorrect',
	Partial = 'partial',
	Skipped = 'skipped'
}